import * as stylex from '@stylexjs/stylex';
import clsx from 'clsx';
import { colors } from '../theme/colors.stylex';
import { controlMetrics } from '../theme/controls.stylex';
import type { PillProps } from './Pill.types';

const styles = stylex.create({
  pill: {
    boxSizing: 'border-box',
    display: 'inline-flex',
    height: '2rem',
    alignItems: 'center',
    borderRadius: '9999px',
    borderWidth: controlMetrics.borderWidth,
    borderStyle: 'solid',
    borderColor: colors.selectionBorder,
    paddingLeft: '0.75rem',
    paddingRight: '0.75rem',
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    whiteSpace: 'nowrap',
    backgroundColor: colors.selectionBackground,
    color: colors.selectionText,
  },
});

export const Pill = ({ children, testId, extraClassNames = '', xstyle }: PillProps) => {
  const styleProps = stylex.props(styles.pill, xstyle);
  return (
    <span {...styleProps} data-testid={testId} className={clsx(styleProps.className, extraClassNames)}>
      {children}
    </span>
  );
};

export default Pill;
